export default __webpack_public_path__ + "img/header-f8bb308e.png";